var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00c4ff",
    d: "M0-.01h640.003v160.43H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 159.763h640.003v160.43H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c4ff",
    d: "M0 319.536h640.003v160.43H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.49 221.33c0 14.564-11.864 26.37-26.5 26.37s-26.498-11.806-26.498-26.37 11.864-26.37 26.5-26.37 26.498 11.806 26.498 26.37z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(1.6452 0 0 1.62 -265.894 -116.567)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "#ffd600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364.43 195.28c-4.34-1.05-8.785.422-10.185.318-1.925 0-6.79-1.68-10.185 0m-5.35 4.892c4.305-3.01 9.115 1.086 10.394.315 3.492-2.294 6.736-1.868 10.08.21 2.155 1.272 5.914-3.71 10.29.315",
    strokeOpacity: 0.387,
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M333.88 205.63c2.275-1.855 9.694-1.925 17.324 2.414 1.155-.28 1.89-1.084.945-2.204-5.74-1.995-12.425-4.515-18.585-2.625-1.68 1.19-1.26 1.96.315 2.415z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#efc000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M333.88 205.63c2.275-1.855 9.694-1.925 17.324 2.414 1.155-.28 1.89-1.084.945-2.204-5.74-1.995-12.425-4.515-18.585-2.625-1.68 1.19-1.26 1.96.315 2.415z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-1.2703 0 0 1.231 768.984 -28.912)",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#efc000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M330.84 211.83c7.525-4.83 17.464-2.31 21.63.315-6.09-1.155-6.196-1.68-10.606-1.785-3.115.106-7.7-.21-11.024 1.47z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "#f0bf00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M348.06 211.3c-3.675 7.665-10.08 7.77-14.594-.42",
    strokeOpacity: 0.387,
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M308.78 234.09c-1.383 1.514-4.77 2.413-7.564 2.01s-3.937-1.96-2.553-3.474c1.384-1.514 4.77-2.413 7.565-2.01s3.937 1.96 2.553 3.474z",
    fillRule: "evenodd",
    fillOpacity: 0.368
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301.898 232.147c.143.353-.297.82-.984 1.045s-1.358.12-1.5-.23c-.144-.354.297-.822.983-1.046s1.36-.12 1.5.23z",
    fillRule: "evenodd",
    fill: "gold"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M349.18 224.5c-4.24 7.127 1.537 2.1 2.475 4.164 1.65 1.913 3.3 1.462 4.276 0 .977-1.65 7.128 3.113 2.927-3.938",
    strokeOpacity: 0.387,
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M341.64 236.31c3.638-.413 9.753-3.188 11.93-.9 1.874-2.063 8.476.6 12.714.9-3.076 1.875-9.302.6-12.265 2.588-2.89-1.763-9.267-.15-12.38-2.588z",
    strokeOpacity: 0.387,
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.625,
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M347.5 239.58c5.514 2.25 6.752 1.913 12.716.225-1.238 3.264-4.398 3.95-6.19 3.826-1.857-.12-4.388.114-6.526-4.05z",
    strokeOpacity: 0.387,
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(1.2703 0 0 1.231 -119.922 -28.068)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    transform: "matrix(-.908 -.861 -.8884 .88 837.014 353.18)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    transform: "matrix(.889 .8794 -.9075 .8614 204.616 -258.71)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    transform: "matrix(-.0073 -1.231 -1.2703 .007 601.74 676.9)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    transform: "matrix(-1.1653 -.49 -.5057 1.1292 835.787 164.23)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    transform: "matrix(-.905 -.864 -.8915 .877 827.91 348.79)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    transform: "matrix(-.4964 -1.133 -1.1693 .481 748.115 528.492)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M349.18 224.5c-4.24 7.127 1.537 2.1 2.475 4.164 1.65 1.913 3.3 1.462 4.276 0 .977-1.65 7.128 3.113 2.927-3.938",
    strokeOpacity: 0.082,
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M341.64 236.31c3.638-.413 9.753-3.188 11.93-.9 1.874-2.063 8.476.6 12.714.9-3.076 1.875-9.302.6-12.265 2.588-2.89-1.763-9.267-.15-12.38-2.588z",
    strokeOpacity: 0.082,
    fillRule: "evenodd",
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.625,
    fill: "#f0bf00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M347.5 239.58c5.514 2.25 6.752 1.913 12.716.225-1.238 3.264-4.398 3.95-6.19 3.826-1.857-.12-4.388.114-6.526-4.05z",
    strokeOpacity: 0.082,
    fillRule: "evenodd",
    transform: "matrix(1.2703 0 0 1.231 -130.873 -28.912)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "#f0bf00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.908 -.861 -.8884 .88 837.014 353.18)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(.889 .8794 -.9075 .8614 204.616 -258.71)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.0073 -1.231 -1.2703 .007 601.74 676.9)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-1.1653 -.49 -.5057 1.1292 835.787 164.23)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.905 -.864 -.8915 .877 827.91 348.79)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.4964 -1.133 -1.1693 .481 748.115 528.492)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(0 -1.231 1.2703 0 41.183 668.378)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-1.2703 0 0 1.231 770.68 -28.276)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(.908 -.861 .8884 .88 -196.843 353.81)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-.889 .8794 .9075 .8614 435.564 -258.39)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(.0073 -1.231 1.2703 .007 38.068 676.9)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(1.1653 -.49 .5057 1.1292 -195.68 164.874)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(.905 -.864 .8915 .877 -188.602 348.79)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(.4964 -1.133 1.1693 .481 -107.76 528.492)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(.908 -.861 .8884 .88 -196.843 353.81)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.889 .8794 .9075 .8614 435.564 -258.39)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(.0073 -1.231 1.2703 .007 38.068 676.9)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(1.1653 -.49 .5057 1.1292 -195.68 164.874)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(.905 -.864 .8915 .877 -188.602 348.79)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(.4964 -1.133 1.1693 .481 -107.76 528.492)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(0 1.231 -1.2703 0 598.48 -184.42)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(1.2703 0 0 -1.231 -131 512.223)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-.908 .861 -.8884 -.88 836.514 130.14)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(.889 -.8794 -.9075 -.8614 204.116 742.347)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-.0073 1.231 -1.2703 -.007 601.612 -192.956)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-1.1653 .49 -.5057 -1.1292 835.352 319.092)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-.905 .864 -.8915 -.877 828.282 135.16)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-.4964 1.133 -1.1693 -.481 747.437 -44.55)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.908 .861 -.8884 -.88 836.514 130.14)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(.889 -.8794 -.9075 -.8614 204.116 742.347)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.0073 1.231 -1.2703 -.007 601.612 -192.956)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-1.1653 .49 -.5057 -1.1292 835.352 319.092)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.905 .864 -.8915 -.877 828.282 135.16)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.4964 1.133 -1.1693 -.481 747.437 -44.55)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-1.2703 0 0 -1.231 759.526 511.997)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(0 1.231 1.2703 0 40.634 -194.91)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-.8884 -.88 .908 -.861 434.918 742.67)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(.9075 .8614 .889 -.8794 -196.835 129.834)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-1.2703 -.007 .0073 -1.231 768.322 515.032)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-.5057 -1.1292 1.1653 -.49 239.93 741.54)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-.8915 -.877 .905 -.864 429.72 734.68)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-1.1693 -.481 .4964 -1.133 615.186 656.337)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.8884 -.88 .908 -.861 434.918 742.67)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(.9075 .8614 .889 -.8794 -196.835 129.834)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M343.17 258.06c-3.977 10.41.38 15.358-1.567 20.964-1.874 5.398-10.025 18.776-3.82 24.59 4.93.227-.853-7.377 9.01-21.456 4.576-6.595-1.195-10.77 3.626-23.707.448-1.106-6.623-2.03-7.25-.39z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-1.2703 -.007 .0073 -1.231 768.322 515.032)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.5057 -1.1292 1.1653 -.49 239.93 741.54)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-.8915 -.877 .905 -.864 429.72 734.68)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.97 258.16c-1.528 11.683-.62 47.577 3.037 46.14 4.05 1.306 4.583-35.162 4.212-45.945-.053-1.194-7.037-1.938-7.25-.195z",
    strokeOpacity: 0.149,
    fillRule: "evenodd",
    transform: "matrix(-1.1693 -.481 .4964 -1.133 615.186 656.337)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "gold"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(1.2703 0 0 1.231 -130.216 -27.957)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(1.2703 0 0 1.231 -131.217 -25.465)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(1.4064 0 0 1.231 -176.307 -23.11)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(1.4064 0 0 1.231 -177.588 -20.892)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(1.6786 0 0 1.231 -267.194 -18.537)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(1.86 0 0 1.231 -326.593 -16.183)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(1.7693 0 0 1.231 -297.676 -13.552)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(1.724 0 0 1.231 -282.503 -10.92)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(1.7693 0 0 1.231 -297.39 -8.426)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(2.223 0 0 1.231 -444.825 -5.517)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.171,
    transform: "matrix(1.9053 0 0 1.231 -341.188 -2.192)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -341.045 .162)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -340.044 3.348)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -339.902 6.12)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -338.186 9.167)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -336.47 11.66)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -334.9 14.57)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -333.04 17.34)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -331.753 19.97)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -329.038 23.165)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.225 0 0 1.231 -104.597 26.07)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -341.045 .162)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -340.044 3.348)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -339.902 6.12)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -338.186 9.167)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -336.47 11.66)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -334.9 14.57)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -333.04 17.34)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -331.753 19.97)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.9053 0 0 1.231 -329.038 23.165)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.078,
    transform: "matrix(1.225 0 0 1.231 -103.975 25.828)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.2703 0 0 1.231 769.71 -28.594)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.2703 0 0 1.231 770.71 -26.1)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.4064 0 0 1.231 815.79 -23.746)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.4064 0 0 1.231 817.08 -21.53)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.6786 0 0 1.231 906.69 -19.175)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.86 0 0 1.231 966.086 -16.82)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.7693 0 0 1.231 937.163 -14.188)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.724 0 0 1.231 921.99 -11.555)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.7693 0 0 1.231 936.888 -9.062)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-2.223 0 0 1.231 1084.31 -6.153)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.134,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.9053 0 0 1.231 980.676 -2.828)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.9053 0 0 1.231 980.53 -.474)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.9053 0 0 1.231 979.53 2.712)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.9053 0 0 1.231 979.385 5.482)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.9053 0 0 1.231 977.674 8.53)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.9053 0 0 1.231 975.963 11.025)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.9053 0 0 1.231 974.382 13.933)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.9053 0 0 1.231 972.525 16.71)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.9053 0 0 1.231 971.25 19.34)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.9053 0 0 1.231 968.523 22.52)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    fillRule: "evenodd",
    fillOpacity: 0.867,
    transform: "matrix(-1.225 0 0 1.231 744.08 25.425)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#00699d"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    transform: "matrix(-1.9053 0 0 1.231 980.53 -.474)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    transform: "matrix(-1.9053 0 0 1.231 979.53 2.712)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    transform: "matrix(-1.9053 0 0 1.231 979.385 5.482)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    transform: "matrix(-1.9053 0 0 1.231 977.674 8.53)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    transform: "matrix(-1.9053 0 0 1.231 975.963 11.025)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    transform: "matrix(-1.9053 0 0 1.231 974.382 13.933)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    transform: "matrix(-1.9053 0 0 1.231 972.525 16.71)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    transform: "matrix(-1.9053 0 0 1.231 971.25 19.34)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    transform: "matrix(-1.9053 0 0 1.231 968.523 22.52)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 202.55h-3.15",
    strokeOpacity: 0.063,
    transform: "matrix(-1.225 0 0 1.231 744.08 25.425)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M330.84 211.83c7.525-4.83 17.464-2.31 21.63.315-6.09-1.155-6.196-1.68-10.606-1.785-3.115.106-7.7-.21-11.024 1.47z",
    strokeOpacity: 0.387,
    fillRule: "evenodd",
    transform: "matrix(-1.2703 0 0 1.231 770.29 -29.23)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "#f0bf00"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M348.06 211.3c-3.675 7.665-10.08 7.77-14.594-.42",
    strokeOpacity: 0.387,
    transform: "matrix(1.2703 0 0 1.231 -97.703 -29.548)",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "none"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M341.925 233.537c-1.43 1.45-4.93 2.31-7.815 1.924s-4.067-1.874-2.637-3.324c1.43-1.45 4.928-2.31 7.815-1.924s4.067 1.876 2.637 3.325z",
    fillRule: "evenodd",
    fillOpacity: 0.368
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M335.073 231.518c.142.352-.298.82-.985 1.045s-1.358.12-1.5-.232c-.144-.35.297-.82.983-1.044s1.36-.12 1.503.232z",
    fillRule: "evenodd",
    fill: "gold"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.2512d6ff27996300ae56683ae7c17357.svg";
export { ForwardRef as ReactComponent };